import BaseObject from '../../base/base_object';
import Loader from '../../utils/module_loader';
import _ from '../../utils/underscore';

class OptionsComponentController extends BaseObject {

    static CLASS = 'OptionsComponentController';


    /**
     * Root component selector.
     *
     * @type {string}
     * @private
     */
    _selector = 'cgp-options-component';


    /**
     * @function
     * @public
     */
    load(optionComponentNameToLoad) {
        let loader = new Loader();
        let optionComponents = loader.optionComponents();

        let findOptionComponentByName = optionComponents.find(optionComponent => this._isOptionExist(optionComponent.CLASS, optionComponentNameToLoad + 'Controller'));

        if (_.isUndefined(findOptionComponentByName)) {
            this.logger.error('Could not find the option component controller => ', optionComponentNameToLoad);
            return null;
        }

        return findOptionComponentByName.create();
    }


    /**
     *
     * @param optionComponentName
     * @param optionComponentNameToLoad
     * @returns {boolean}
     * @private
     */
    _isOptionExist(optionComponentName, optionComponentNameToLoad) {
        return optionComponentName === optionComponentNameToLoad;
    }

    getReminderInterval() {
        return this.load('ReminderSettings').getOptions().reminder;
    }
}


export default OptionsComponentController;